import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./GestionDesarrollo.css";
import Tecnologias from "../../services/components/Tecnologias";

interface Item {
  imagen?: string;
  descripcion: string;
}

interface GestionDesarrolloProps {
  gestion: Item[];
  alcance: Item[];
  tecnologia?: any;
}

export default function GestionDesarrollo({ gestion, alcance, tecnologia }: GestionDesarrolloProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* Sección de gestión */}
      <div className="componente-desarrollo1">
        <h3>{t("gestion.gestion_title")}</h3>
        <div className="contenedor-desarrollo">
          {Array.isArray(gestion) && gestion.map((item, idx) => (
            <div className="grupo-desarrollo1" key={idx}>
              <div className="fila-desarrollo">
                {item.imagen && (
                  <img
                    src={item.imagen}
                    alt="Imagen gestión"
                    className="imagen-desarrollo"
                  />
                )}
                <motion.p
                  className="descripcion-desarrollo"
                  initial={{ opacity: 0, y: -20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {item.descripcion}
                </motion.p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Sección de alcance */}
      <div className="componente-desarrollo1">
        <h3>{t("gestion.alcance_title")}</h3>
        <div className="contenedor-desarrollo2">
          {Array.isArray(alcance) && alcance.map((grupo, idx) => (
            <div className="grupo-desarrollo2" key={idx}>
              <div className="fila-desarrollo">
                {grupo.imagen && (
                  <img
                    src={grupo.imagen}
                    alt="Imagen alcance"
                    className="imagen-desarrollo"
                  />
                )}
                <motion.p
                  className="descripcion-desarrollo"
                  initial={{ opacity: 0, y: -20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  viewport={{ once: false, amount: 0.3 }}
                  transition={{ duration: 0.6 }}
                >
                  {grupo.descripcion}
                </motion.p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tecnologías */}
      <div className="componente-desarrollo">
        <h3>{t("home.tecnologias.titulo")}</h3>
        <Tecnologias />
      </div>
    </>
  );
}
